import { csColorBackground } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css, CSSResult } from 'lit'

export const style: CSSResult = css`
  .active-filters {
    --cse-paper-secondary-background-color: ${csColorBackground.primary};
    --cse-paper-padding-x: 0;
    --cse-paper-padding-y: 0;
  }

  .filters-content {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing06};
  }

  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 10;
    pointer-events: none;
  }
`
